<template>
  <div class="Paginate paginate-warp w-full py-4">
    <sliding-pagination
      class="hidden md:block"
      :current="pagination.currentPage"
      :total="pagination.length"
      @page-change="pageChangeHandler"
    >
    </sliding-pagination>
  </div>
</template>

<script>
import SlidingPagination from 'vue-sliding-pagination'
export default {
  name: 'pagination',

  props: {
    pagination: {
      type: Object
    }
  },

  components: {
    SlidingPagination
  },

  methods: {
    pageChangeHandler (selectedPage) {
      this.$emit('selectedPage', selectedPage)
    }
  }
}
</script>

<style lang="scss">
  @import "~vue-sliding-pagination/dist/style/sliding-pagination";
  .paginate-warp {
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .c-sliding-pagination {
    text-align: center;
    margin: 1.5em 0;
  }
  .c-sliding-pagination__list {
    display: flex;
  }
  .c-sliding-pagination__list-element {
    font-weight: 900;
    background: transparent;
    color: #808080;
    padding: 0;
    // border: 3px solid #0F455C;
    // border-radius: 0;
    margin-bottom: 0;
    margin-right: .5em;
    font-size: 20px;
    font-weight: 800;
    &:hover {
      background: #2c3e50;
      color: #ffffff;
    }
    .c-sliding-pagination__page {
      display: block;
      padding: 0.5em;
      font-size: 1rem;
      border-radius: 0;
      cursor: pointer;
      font-weight: 900;
    }
  }
  .c-sliding-pagination__list-element--active {
    background: #2c3e50;
    color: #ffffff;
    cursor: default;
  }
  .c-sliding-pagination__list-element
  ~ .c-sliding-pagination__list-element--disabled {
    cursor: default;
    border: 3px solid transparent;
    background-color: transparent;
    color: #2c3e50;
    cursor: default !important;
    pointer-events: none;
  }
</style>
